// WINDOW READY
$(document).ready(function () {

	// Main menu
	menuOpen();

	if ($('input[type="range"]').length) {

		$('input[type="range"]').each(function () {
			$(this).ionRangeSlider({
				min: $(this).attr('min'),
				max: $(this).attr('max'),
				step: $(this).attr('step')
			});
		});
	}

	$('.filter-trigger').on('click', function () {
		$('.filter-block').toggle();
	});

	$('.time-trigger').on('click', function () {
		$(this).toggleClass('active');
		$('.rangeslider-container').toggle();
	});

	$('.date-trigger').on('click', function () {
		$(this).siblings().removeClass('active');
		$(this).toggleClass('active');
		$('.datepicker').datepicker('show');
	});

	if ($('.date-trigger').length) {
		$('.datepicker').datepicker({
			autoclose: true,
			todayHighlight: true,
			datesDisabled: ['08/06/2018', '08/21/2018']
		});
	}
});

// WINDOW LOAD
$(window).on('load', function () {

});

// WINDOW RESIZE
$(window).on('resize', function () {
});

// Return Window Height
function win_height() {
	return $(window).outerHeight();
}

// Return Window Width
function win_width() {
	return $(window).width();
}

// Return Heade Height
function header_height() {
	return $('.header-main').outerHeight();
}

/********************************************
 * HEADER WHEN SCROLLING
 ********************************************/

// Turns on when we scroll past half the window height
$(window).scroll(function () {

	var scroll = $(window).scrollTop();
	var scrollOffset = 150;

	if (scroll > scrollOffset) {
		$('body').addClass('is-scrolling-menu');
	} else {
		$('body').removeClass('is-scrolling-menu');
	}
});